import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "https://api.eyeonwellness.org/api",
  headers: {
    "Content-Type": "application/json",
  },
});


axiosInstance.interceptors.request.use(
  (config) => {
    const authData = localStorage.getItem("authData");
    if (authData) {
      const { token } = JSON.parse(authData);
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || "";

    // Do not force-navigation on every 401.
    // Some endpoints can fail temporarily (or with stale tokens) and should be handled by caller UI.
    if (status === 401 && requestUrl.includes("/auth/me")) {
      localStorage.removeItem("authData");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
